import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CookieConsentSettingState } from '@as-react/common-types';
import { Box } from '@as/cotopaxi';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Login } from '../../account/authentication/Login';
import { authActions } from '../../../redux/authentication/actions/AuthActions.creators';
import { makeGetLoginError, makeGetLoginLoading, makeGetResetPasswordState, } from '../../../redux/authentication/selectors/AuthSelectors';
import { ForgotPassword } from '../../account/authentication/ForgotPassword';
import { makeGetCookieConsentSettingAvailable } from '../../../redux/cookieConsent/selectors/CookieConsentSelector';
import { MobileNavigationItemContent } from './MobileNavigationItemContent';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { DELAY } from '../../../constants/GeneralConstants';
export const MobileNavigationLoginLevel = ({ actionUri, registrationLink, isTabActive, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
    const [email, setEmail] = useState('');
    const loading = useSelector(makeGetLoginLoading());
    const cookieConsentSettingAvailable = useSelector(makeGetCookieConsentSettingAvailable());
    const resetPasswordState = useSelector(makeGetResetPasswordState());
    const loginError = useSelector(makeGetLoginError());
    const dispatch = useDispatch();
    const handleLoginSubmit = (values) => dispatch(authActions.login({
        username: values.email,
        password: values.password,
        keepSignedIn: values.keepSignedIn,
        reloadOnSuccess: true,
    }));
    const resetForgotPasswordState = () => {
        (resetPasswordState.success || resetPasswordState.error) &&
            dispatch(authActions.createResetCredentialsSuccessAction(null));
    };
    const handleResetPasswordSubmit = (values) => dispatch(authActions.createResetCredentialsAction(values.email));
    const handleForgotPasswordEmailChange = (email) => {
        setEmail(email);
        resetForgotPasswordState();
    };
    const toggleView = () => {
        setForgotPasswordActive(!forgotPasswordActive);
        resetForgotPasswordState();
    };
    useEffect(() => {
        forgotPasswordActive && setTimeout(() => setForgotPasswordActive(false), DELAY.DELAY_250); // reset state after menu animations completes
    }, [isTabActive]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { mobile: { spacing: { marginBottom: 1 } }, children: _jsx(MobileNavigationItemContent, { emphasized: true, children: forgotPasswordActive ? t('account.login.title.password.forgotten') : t('account.login.title.login') }) }), forgotPasswordActive ? (_jsx(ForgotPassword, { onSubmit: handleResetPasswordSubmit, errorFeedback: resetPasswordState.error, successFeedback: resetPasswordState.success, initialEmail: email, backToLoginClicked: toggleView, onEmailChange: handleForgotPasswordEmailChange })) : (_jsx(Login, { login: {
                    action: actionUri,
                    onSubmit: handleLoginSubmit,
                    errorFeedback: loginError,
                    forgotPasswordClicked: toggleView,
                    initialEmail: email,
                    loading,
                }, facebook: {}, registrationLink: registrationLink, socialLogin: payload => dispatch(authActions.createSocialLoginAction(payload)), onAuthResetForm: () => dispatch(authActions.resetError()), onEmailChange: setEmail, cookieConsentSettingAvailable: cookieConsentSettingAvailable === CookieConsentSettingState.CONSENTS_AVAILABLE }))] }));
};
